
































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { InfoState } from '../../../../core/core.store';
import { SwIcon } from '@libs-uuif/shared/sw-icon';

@Component({
  components: {
    ...UUIFComponent,
    SwTextarea,
    SwIcon,
  },
})
export default class ManualLicensesDialog extends SwExtendedVue {
  addThisKey: string = '';
  sha256checksum: string = '';

  @Prop()
  addThisKeyText: string;

  @Prop()
  shachecksum: string;

  @Prop()
  showAddManualKeysetDialog: boolean;

  created() {
  }
  mounted() {
    this.addThisKey = this.addThisKeyText;
    this.sha256checksum = this.shachecksum;
    setTimeout(() => {
      const textarea = ((this.$refs.manuallicensetextarea as any).$refs.textarea) as HTMLInputElement;
      textarea.select();
    });
  }

  get getSHAChecksum() {
    const str = this.sha256checksum;
    if (this.sha256checksum.length > 40) {
      return `${str.slice(0, 35)}.....`;
    }
  }

  copyToClipboard(keyset: string) {
    window.navigator.clipboard.writeText(keyset);
    this.showMessage();
  }

  copySHA() {
    window.navigator.clipboard.writeText(this.sha256checksum);
    this.showMessage();
  }

  showMessage() {
    const message: InfoState = { infoType: 'informational', infoMsg: (this.$t('products.maintainceKey.copied')
    .toString()) };
    this.$store.commit('enqueueMessage', message);
  }

  closeDialog() {
    this.$emit('closeDialog');
  }
}
